const store = {
    namespaced: true,
    state: {
        pagination: {
            current_page: null,
            total_pages: null,
        },
        permissions: [],
        permission_groups: [],
    },
    actions: {
        fetch_permissions: function(context, payload) {
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_permissions).parse(
                {},
                ""
            )

            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(function (response) {
                    if (response.data.status == "success") {
                        context.commit('set_permissions', response.data.permissions)
                    } else {
                        return Promise.reject("Failed to fetch Permissions.");
                    }
                })
                .catch(function (error) {
                    return Promise.reject("Error to fetch Permissions.");
                });
        },
        fetch_permission_groups: function(context, payload) {
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_permission_groups).parse(
                {},
                ""
            )

            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(function (response) {
                    if (response.data.status == "success") {
                        context.commit('set_permission_groups', response.data.permission_groups)
                    } else {
                        return Promise.reject("Failed to fetch PermissionGroups.");

                    }
                })
                .catch(function (error) {
                    return Promise.reject("Error to fetch PermissionGroups.");
                });
        },
    },
    mutations: {
        set_current_page: function(state, payload) {
            state.pagination.current_page = payload;
        },
        set_total_pages: function(state, payload) {
            state.pagination.total_pages = payload;
        },
        set_permissions: function(state, payload) {
            state.permissions = payload;
        },
        set_permission_groups: function(state, payload) {
            state.permission_groups = payload;
        },
    }
}

export default store
